/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v9'

export interface DownloadRFPMatchingCarriersQueryParams {
  /**
   * Filters
   */
  filters?: { [key: string]: any }
}

export type DownloadRFPMatchingCarriersProps = Omit<
  GetProps<void, unknown, DownloadRFPMatchingCarriersQueryParams, void>,
  'path'
>

/**
 * Download csv of rfp carrier matches
 */
export const DownloadRFPMatchingCarriers = (props: DownloadRFPMatchingCarriersProps) => (
  <Get<void, unknown, DownloadRFPMatchingCarriersQueryParams, void>
    path='/v9/request_for_proposal_matching_carriers/download'
    {...props}
  />
)

export type UseDownloadRFPMatchingCarriersProps = Omit<
  UseGetProps<void, unknown, DownloadRFPMatchingCarriersQueryParams, void>,
  'path'
>

/**
 * Download csv of rfp carrier matches
 */
export const useDownloadRFPMatchingCarriers = (props: UseDownloadRFPMatchingCarriersProps) =>
  useGet<void, unknown, DownloadRFPMatchingCarriersQueryParams, void>(
    `/v9/request_for_proposal_matching_carriers/download`,
    props
  )
